import CaptainAssistantAPI from 'dashboard/api/captain/assistant';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'CaptainAssistant',
  API: CaptainAssistantAPI,
  actions: mutationTypes => ({
    async updateStatus({ commit }, { assistantId, status }) {
      commit(mutationTypes.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await CaptainAssistantAPI.updateStatus({
          assistantId,
          status,
        });
        const updated = response.data || {};
        commit(mutationTypes.EDIT, { id: assistantId, ...updated });
        return updated;
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { updatingItem: false });
      }
    },

    async addTestConversation(_, { assistantId, conversationId }) {
      const response = await CaptainAssistantAPI.addTestConversation({
        assistantId,
        conversationId,
      });
      return response.data;
    },

    async removeTestConversation(_, { assistantId, conversationId }) {
      const response = await CaptainAssistantAPI.removeTestConversation({
        assistantId,
        conversationId,
      });
      return response.data;
    },

    async fetchTestConversations(_, { assistantId }) {
      const response = await CaptainAssistantAPI.getTestConversations({
        assistantId,
      });
      return response.data;
    },

    async fetchMetrics(_, { assistantId }) {
      const response = await CaptainAssistantAPI.getMetrics({ assistantId });
      return response.data;
    },

    async pauseAll({ commit }) {
      const response = await CaptainAssistantAPI.pauseAll();
      // Reload assistants to refresh status badges
      const list = await CaptainAssistantAPI.get();
      commit(mutationTypes.SET, list.data?.payload || list.data);
      return response.data;
    },

    async resumeAll({ commit }) {
      const response = await CaptainAssistantAPI.resumeAll();
      const list = await CaptainAssistantAPI.get();
      commit(mutationTypes.SET, list.data?.payload || list.data);
      return response.data;
    },

    async fetchContactMemory(_, { contactId }) {
      const response = await CaptainAssistantAPI.getContactMemory({
        contactId,
      });
      return response.data;
    },
  }),
});
